"use client";
//? Library Imports ------------------------------------------------------------>
import { flushSync } from "react-dom";
import { useSelector } from "react-redux";
import { Col, Row, Radio, Checkbox, Typography } from "antd";
import { removeCommasAndConvertToNumber } from "../../../..//../functions/HelperFunctions/index";

//? Modules -------------------------------------------------------------------->
// import MediaQueryHook from "../../../../../hooks/useMediaQuery/MediaQueryHook";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function AddonOptions({
  template,
  userAgent,
  ProductDetail,
  LineItemAddons,
  setLineItemAddons,
  setViewBagItemsState,
  pushedVariants,
  setPushedVariants,
  selectedValueFromOptions,
}) {
  //? Hooks ---------------------------------------------------------------------->
  // const { isMobile, isTablet } = MediaQueryHook();
  const { isMobile, isTablet, isDesktop } = userAgent;

  //? Redux States --------------------------------------------------------------->
  const defaultCurrency = useSelector(
    (state) => state?.multiLocation?.defaultCurrency
  );

  //? Functions ------------------------------------------------------------------>
  const selectAddons = (e, addonName) => {
    let pushedVariantsArrayToRemove = [...pushedVariants];

    if (selectedValueFromOptions?.option1 !== "-9346535324534") {
      const indexToRemove = pushedVariantsArrayToRemove.findIndex(
        (obj) => obj?.option1 === selectedValueFromOptions?.option1
      );

      if (indexToRemove !== -1) {
        pushedVariantsArrayToRemove.splice(indexToRemove, 1);
        setPushedVariants([...pushedVariantsArrayToRemove]);
      }
    }
    setViewBagItemsState(false);
    const name = e.target.name;
    // const type = e.target.type;
    const value = e.target.value;
    const checked = e.target.checked;

    const SelectedAddons = [...LineItemAddons];
    let flag = false;

    const addOn = {
      name: name,
      option: value,
      addonName: addonName,
    };

    if (!LineItemAddons.length) {
      SelectedAddons.push(addOn);
      setLineItemAddons(SelectedAddons);
    } else {
      SelectedAddons.forEach((LineItem, index) => {
        if (LineItem.option === addOn.option && checked === false) {
          flag = true;
          SelectedAddons.splice(index, 1);
        }
      });

      if (!flag && checked === true) {
        SelectedAddons.push(addOn);
      }

      setLineItemAddons(SelectedAddons);
    }
  };

  const addOnSelection = (e) => {
    const name = e.target.name;
    const type = e.target.type;
    const value = e.target.value;
    const checked = e.target.checked;

    var SelectedValues;
    if (SelectedStitchingOptions) {
      SelectedValues = [...SelectedStitchingOptions];
    } else {
      SelectedValues = [...selectedOptions];
    }

    const foundPair = template?.add_ons?.find(
      (selected) => selected?.name === name
    );

    const keyPairIndex = foundPair?.options?.findIndex(
      (option) => option?.id === value
    );
    const newObj = foundPair?.options[keyPairIndex];

    if (newObj) {
      // newObj.addonName = name;
      newObj["addonName"] = name;
    }

    const index =
      SelectedValues?.length &&
      SelectedValues?.findIndex((selected) => selected?.name === newObj?.name);

    const flag = foundPair?.options?.some((option) => option?.id === value);

    if (checked && type === "checkbox") {
      SelectedValues?.push(newObj);
    } else if (!checked && type === "checkbox") {
      SelectedValues?.splice(index, 1);
    } else {
      if (flag) {
        SelectedValues?.splice(index, 1, newObj);
      } else {
        SelectedValues?.push(newObj);
      }
    }

    const LineItemOptions = SelectedValues?.map(({ id: option }) => ({
      option,
    }));
    flushSync(() => {
      if (
        window.location.pathname === "/cart/checkout" ||
        window.location.pathname.includes("/cart")
      ) {
        const selectedProductObject = SelectedValues;
        selectedProductObject.ProductId = ProductDetail?.id;

        setSelectedOptions(selectedProductObject);
      } else {
        setLineItemAddons(LineItemOptions);
        setSelectedOptions(SelectedValues);
      }

      if (setSelectedStitchingOptions) {
        setSelectedStitchingOptions(SelectedValues);
      }
    });
  };

  const changeStitchingOptionsClick = (e, index, addonName, selectedValue) => {
    const name = selectedValue;

    const value = e.target.value;
    const checked = e.target.checked;

    const SelectedAddons = [...LineItemAddons];

    let flag = false;

    const addOn = {
      name: name,
      option: value,
      addonName: addonName,
    };

    var itemIndex = null;

    if (LineItemAddons.length > 0) {
      SelectedAddons.forEach((dataItem, i) => {
        template?.add_ons.forEach((LineItem, j) => {
          LineItem?.options.forEach((item, k) => {
            if (item.id === dataItem.option && LineItem.name === addonName) {
              itemIndex = i;
            }
          });
        });
      });

      if (itemIndex == null) {
        SelectedAddons.push(addOn);
      } else {
        SelectedAddons.splice(itemIndex, 1, addOn);
      }
    } else {
      SelectedAddons.push(addOn);
    }

    setLineItemAddons(SelectedAddons);
  };

  const findOptionByAddOnName = (addOnName, inputType) => {
    var itemId = 0;

    const SelectedAddons = [...LineItemAddons];
    if (inputType !== "radio") {
      template?.add_ons.forEach((LineItem, j) => {
        if (LineItem.name === addOnName) {
          var existsObject = false;
          LineItemAddons.forEach((dataItem, i) => {
            LineItem?.options.forEach((dataOption, k) => {
              if (dataItem.option === dataOption.id) {
                existsObject = true;
              }
            });
          });

          if (!existsObject) {
            const addOn = {
              name: LineItem?.options[0]?.name,
              option: LineItem?.options[0]?.id,
              addonName: addOnName,
            };
            SelectedAddons.push(addOn);
            setLineItemAddons(SelectedAddons);
            return;
          }
          return;
        }
      });
    }
    if (LineItemAddons.length > 0) {
      LineItemAddons.forEach((dataItem, i) => {
        template?.add_ons.forEach((LineItem, j) => {
          LineItem?.options.forEach((item, k) => {
            if (item.id === dataItem.option && LineItem.name === addOnName) {
              itemId = dataItem.option;
              return itemId;
            }
          });
          return itemId;
        });
        return itemId;
      });

      return itemId;
    }
  };

  return (
    <Col
      className={
        isMobile || isTablet
          ? "AddonOptions backgroundLight paddingTop10 paddingBottom10 padding0"
          : "AddonOptions border paddingTop10 paddingBottom10"
      }
    >
      {/* With Multiple Addons Options ---------> */}

      {template?.add_ons?.length
        ? template?.add_ons?.map((addOn, key) => {
            const addonName = addOn?.name;
            return (
              <Col
                span={24}
                key={key}
                className={
                  isMobile || isTablet
                    ? "backgroundLight width100"
                    : "padding0 flex flexColumn width100"
                }
              >
                <Col
                  span={24}
                  className={
                    key > 0
                      ? "paddingTop10 paddingLeft0 paddingRight0"
                      : "padding0"
                  }
                >
                  <Text style={{ color: !isDesktop ? "#989898" : "" }}>
                    {addOn?.name}
                  </Text>
                </Col>

                {addOn?.input_type === "checkbox" ? (
                  //? Product Aditional Info like stitching, embalishment --------------->
                  addOn?.options?.map((option, checkboxKey) => {
                    return (
                      <Checkbox
                        key={checkboxKey}
                        value={option?.id}
                        // name={addOn?.name}
                        name={option?.name}
                        onChange={(e) => selectAddons(e, addonName)}
                        className="radio_container marginTop10 checkboxBorder width100"
                        // checked={
                        //   selectedOptions
                        //     ? selectedOptions[checkboxKey]?.id
                        //     : false
                        // }
                        // defaultChecked={
                        //   EditProduct?.add_ons[checkboxKey]?.option
                        // }
                        checked={LineItemAddons.find(
                          (lineItem) => lineItem.option === option.id
                        )}
                      >
                        <Row justify="">
                          <Col>
                            <Text className={!isDesktop ? "font12" : ""}>
                              {option?.name}
                            </Text>
                          </Col>

                          <Col flex="1 1 1" className="marginLeft5">
                            <Text
                              className={
                                !isDesktop
                                  ? "font12Bold marginLeft5"
                                  : "font14Bold marginLeft5"
                              }
                            >
                              {removeCommasAndConvertToNumber(
                                option?.discounted_price
                              ) <= 0 ? (
                                "Free"
                              ) : (
                                <>
                                  +{defaultCurrency}&nbsp;
                                  {option?.discounted_price}
                                </>
                              )}
                            </Text>
                          </Col>
                        </Row>
                      </Checkbox>
                    );
                  })
                ) : addOn?.input_type === "radio" ? (
                  <Radio.Group
                    key={key}
                    name={addOn?.name}
                    buttonStyle="solid"
                    style={{ width: "100%" }}
                    // onChange={(e) => addOnSelection(e)}
                    defaultValue={
                      findOptionByAddOnName(addOn?.name, addOn?.input_type) ||
                      (addOn?.options?.length > 0 && addOn?.options[0]?.id,
                      addOn?.input_type)
                    }
                    // defaultValue={selectedOptions[key]?.id}
                    // defaultValue={SelectedStitchingOptions[key]?.id}
                  >
                    {addOn?.options?.map((option, radioKey) => {
                      return (
                        <Radio
                          key={radioKey}
                          value={option?.id}
                          className="radio_container marginTop5 marginTop5"
                          onChange={(e) =>
                            changeStitchingOptionsClick(
                              e,
                              key,
                              addOn?.name,
                              option.name
                            )
                          }
                        >
                          <Row justify="space-between">
                            <Col flex="1 1 auto">
                              <Text className={!isDesktop ? "font12" : ""}>
                                {option?.name}
                              </Text>
                            </Col>

                            <Col flex="1 1 auto" className="flexEnd">
                              <Text
                                className={
                                  !isDesktop
                                    ? "font12Bold marginLeft5"
                                    : "font14Bold marginLeft5"
                                }
                              >
                                {removeCommasAndConvertToNumber(
                                  option?.discounted_price
                                ) <= 0 ? (
                                  "Free"
                                ) : (
                                  <>
                                    +{defaultCurrency}&nbsp;
                                    {option?.discounted_price}
                                  </>
                                )}
                              </Text>
                            </Col>
                          </Row>
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                ) : addOn?.input_type === "radio button" ? (
                  //? Product Options for Custom Stitching like Size, Color --------------->
                  <Radio.Group
                    key={key}
                    name={addOn?.name}
                    buttonStyle="solid"
                    style={{ width: "100%" }}
                    // onChange={(e) => addOnSelection(e)}
                    defaultValue={
                      findOptionByAddOnName(addOn?.name) ||
                      (addOn?.options?.length > 0 && addOn?.options[0]?.id)
                    }
                    // defaultValue={selectedOptions[key]?.id}
                    // defaultValue={SelectedStitchingOptions[key]?.id}
                  >
                    {addOn?.options?.map((option, radioButtonKey) => {
                      return (
                        <Radio.Button
                          value={option?.id}
                          key={radioButtonKey}
                          className="marginRight10 marginBottom10"
                          onChange={(e) =>
                            changeStitchingOptionsClick(
                              e,
                              key,
                              addOn?.name,
                              option.name
                            )
                          }
                        >
                          {option?.name}
                        </Radio.Button>
                      );
                    })}
                  </Radio.Group>
                ) : null}
              </Col>
            );
          })
        : null}
    </Col>
  );
}
